module.exports = __webpack_public_path__ + "img/timer.447c5efa.svg";